import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { UiState } from './ui.state';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([UiState])
  ],
  declarations: []
})
export class UiStoreModule { }
